import React, { useState } from 'react';
import { PrimaryButton, SecondaryButton } from '@/components/Buttons';

const CommonSettings = ({settings}) => {

  const handleSettingChange = (key, value) => {
    setSettings(prev => ({
      ...prev,
      [key]: value
    }));
  };

  if(!settings) return null;

  return (
    <div>
      
      <div className="space-y-6">
        {/* Notifications */}
        <div>
          <h4 className="text-md font-medium text-slate-800 dark:text-slate-100 mb-4">
            Sync Configuration
          </h4>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div>
              <label className="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-2">
                Sync Interval (minutes)
              </label>
              <select
                value={settings.syncInterval}
                onChange={(e) =>
                  handleSettingChange("syncInterval", e.target.value)
                }
                className="w-full px-3 py-2 border border-slate-300 dark:border-slate-600 rounded-md bg-white dark:bg-slate-700 text-slate-800 dark:text-slate-100"
              >
                <option value="15">15 minutes</option>
                <option value="30">30 minutes</option>
                <option value="60">1 hour</option>
                <option value="120">2 hours</option>
              </select>
            </div>

            <div>
              <label className="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-2">
                Retry Attempts
              </label>
              <input
                type="number"
                value={settings.retryAttempts}
                onChange={(e) =>
                  handleSettingChange("retryAttempts", e.target.value)
                }
                className="w-full px-3 py-2 border border-slate-300 dark:border-slate-600 rounded-md bg-white dark:bg-slate-700 text-slate-800 dark:text-slate-100"
                min="1"
                max="10"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-2">
                Timeout (seconds)
              </label>
              <input
                type="number"
                value={settings.timeoutSeconds}
                onChange={(e) =>
                  handleSettingChange("timeoutSeconds", e.target.value)
                }
                className="w-full px-3 py-2 border border-slate-300 dark:border-slate-600 rounded-md bg-white dark:bg-slate-700 text-slate-800 dark:text-slate-100"
                min="10"
                max="300"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-2">
                Batch Size
              </label>
              <input
                type="number"
                value={settings.batchSize}
                onChange={(e) =>
                  handleSettingChange("batchSize", e.target.value)
                }
                className="w-full px-3 py-2 border border-slate-300 dark:border-slate-600 rounded-md bg-white dark:bg-slate-700 text-slate-800 dark:text-slate-100"
                min="10"
                max="1000"
              />
            </div>
          </div>
        </div>

        {/* Save Button */}
        
      </div>
    </div>
  );
};

export default CommonSettings; 